import React from "react";
import ReactECharts from 'echarts-for-react';

const SERVICE_COLORS = {
  TTT: "#1e6c56",
  TTS: "#c99718",
  STT: "#00b074",
  STS: "#ff8a3d",
};

const ServiceRequestsBarChart = ({ serviceMetrics }) => {
  const safeMetrics = serviceMetrics || {};

  const option = {
    tooltip: { trigger: "axis", axisPointer: { type: "shadow" } },
    grid: { left: "10%", right: "4%", bottom: "8%", top: "4%", containLabel: true },
    xAxis: {
      type: "value",
      axisLine: { show: false },
      splitLine: { lineStyle: { color: "#F3F4F6" } },
      axisLabel: { color: "#9CA3AF", fontSize: 12 }
    },
    yAxis: {
      type: "category",
      data: ["Speech Translations", "Speech-To-Text", "Text-To-Speech", "Text-To-Text"],
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { color: "#374151", fontSize: 12, fontWeight: "500" }
    },
    series: [
      {
        name: "Requests",
        type: "bar",
        barWidth: 26,
        itemStyle: { borderRadius: [0, 8, 8, 0] },
        data: [
          { value: safeMetrics.sts?.totalRequests || 0, itemStyle: { color: SERVICE_COLORS.STS } },
          { value: safeMetrics.stt?.totalRequests || 0, itemStyle: { color: SERVICE_COLORS.STT } },
          { value: safeMetrics.tts?.totalRequests || 0, itemStyle: { color: SERVICE_COLORS.TTS } },
          { value: safeMetrics.ttt?.totalRequests || 0, itemStyle: { color: SERVICE_COLORS.TTT } }
        ]
      }
    ]
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6">
      <h3 className="text-xl font-bold text-gray-900 mb-4">Successful API Requests per Service (Last 30 Days)</h3>
      <div className="h-72">
        <ReactECharts option={option} style={{ height: "100%", width: "100%" }} />
      </div>
    </div>
  );
};

export default ServiceRequestsBarChart;
